import Axios from "../config/config";
export const LMS_STORAGE = '#';


export const ME_API = async () => {
  try {
    const response = await Axios.get("auth/me");
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const LOGIN_API = async (body) => {
  try {
    const response = await Axios.post('auth/login', body);
    return response;
  } catch (error) {
    console.error(error);
  }
};
export const SLOTS_API = async (body) => {
  try {
    const response = await Axios.post("slots", body);
    return response;
  } catch (error) {

    throw error;
  }
};

export const ENROLL_API = async (body) => {
  try {
    const response = await Axios.post("dashboard/enroll", body);
    return response;
  } catch (error) {

    throw error;
  }
};



export const VIEW_ENROLL_SLOT = async (body) => {
  try {
    const response = await Axios.post("view-enrolled-slots", body);
    return response;
  } catch (error) {

    throw error;
  }
};


export const START_EXAM = async (body) => {
  try {
    const response = await Axios.post("/start-exam", body);
    return response;
  } catch (error) {

    throw error;
  }
};


export const EDIT_PROFILE_API = async (body) => {
  try {
    const response = await Axios.post('edit-profile', body);
    return response;
  } catch (error) {
    console.error(error);
  }
};
export const EXAMINATION_LIST = async (body) => {
  try {
    const response = await Axios.post('user/exam-list', body);
    return response;
  } catch (error) {
    console.error(error);
  }
};

// Candidate exam history (results are included only when published by admin)
export const EXAM_HISTORY_API = async (body) => {
  const response = await Axios.post("user/exam-history", body);
  return response;
};


// ---------------- Candidate Portal (multi-exam, prototype parity) ----------------
export const PORTAL_EXAMS_API = async () => {
  const response = await Axios.post("user/portal/exams", {});
  return response.data;
};

export const PORTAL_EXAM_DETAIL_API = async (exam_code) => {
  const response = await Axios.post("user/portal/exam-detail", { exam_code });
  return response.data;
};

export const PORTAL_CATALOG_API = async () => {
  const response = await Axios.post("user/portal/catalog", {});
  return response.data;
};

export const PUBLIC_CERTIFICATE_VERIFY_API = async (certificateId) => {
  const response = await Axios.get("certificate/verify", { params: { certificate_id: certificateId } });
  return response.data;
};

export const PORTAL_PREP_API = async () => {
  const response = await Axios.post("user/portal/prep", {});
  return response.data;
};

// Resource PDF bytes for the in-platform viewer (view only, no download link)
export const PORTAL_GUIDE_VIEW_API = (examCode, index) =>
  Axios.post("user/portal/guide-view", { exam_code: examCode, index }, { responseType: "arraybuffer" });

export const PORTAL_CERTIFICATE_SUBMIT_API = async (formData) => {
  const response = await Axios.post("user/portal/certificate/submit", formData);
  return response.data;
};

export const FORGOT_PASSWORD_API = async (email) => {
  const response = await Axios.post("auth/forgot-password", { email });
  return response.data;
};

// Throws on error so the form can show field-level validation messages.
export const UPDATE_PROFILE_API = async (body) => {
  const response = await Axios.post("edit-profile", body);
  return response.data;
};
